'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SVGContainer = function SVGContainer(props) {
  var _classnames;

  var SVGClass = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, props.className, props.className !== undefined), _defineProperty(_classnames, _styles2.default['svg--small'], props.size === 'small'), _defineProperty(_classnames, _styles2.default['svg--medium'], props.size === 'medium'), _defineProperty(_classnames, _styles2.default['svg--large'], props.size === 'large'), _classnames));

  return _react2.default.createElement(
    'svg',
    {
      className: SVGClass,
      viewBox: '0 0 32 32',
      version: '1.1'
    },
    props.children
  );
};

SVGContainer.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  size: _react.PropTypes.oneOf(['small', 'medium', 'large']).isRequired
};

SVGContainer.defaultProps = {
  size: 'small'
};

exports.default = SVGContainer;